import { callApi } from "@disco/utils";

export const saveAction = async (action, data, uid) => {
  return await callApi('/steps/action', {
    method: 'POST',
    body: { data: action, userId: uid, sessionId: data.sessionId, stepId: data.currentStep.id },
  });
};
